import {
  applyCoupon,
  deleteCartItem,
  deleteCoupon,
  updateCartItem,
} from '@/services/cart';
import { getCookie, setCookie } from 'cookies-next';
import useCart from '@/store/cart.store';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { toast } from 'sonner';
import {
  coupon_redemption,
  event_add_to_cart,
  event_error_boundry,
  event_remove_from_cart,
  update_cart_event,
} from '@/utils/gtm';

const useHandleCart = () => {
  const { resetCart, removeItem, refetchCart, updateItem, cartItems } = useCart(
    (store) => store
  );

  const quote = getCookie('quote');
  const mage = getCookie('mage');
  const [loading, setLoading] = useState('');
  const locale = useLocale();
  const deleteItemFromCart = async (item_id) => {
    setLoading('deleting');
    const item = cartItems.find((item) => item.item_id === item_id);
    !!item && event_remove_from_cart(item);
    const res = await deleteCartItem(item_id, mage, quote);

    if (res?.status === 404) {
      removeItem(item_id);
    }

    if (res?.data?.quoteId !== undefined && res?.data?.quoteId != quote) {
      setCookie('quote', res?.data?.quoteId);
      resetCart();
    }
    if (res?.status === 200) {
      removeItem(item_id);

      refetchCart && (await refetchCart());
      setLoading('');
      toast.success(
        locale === 'en'
          ? 'Item deleted from cart'
          : 'تم إزالة المنتج من الحقيبة'
      );
      update_cart_event(cartItems?.filter((info) => info?.item_id !== item_id));
    } else {
      setLoading('');
      event_error_boundry(
        locale === 'en'
          ? 'Error Occured, please try again'
          : 'حدث خطأ, برجاء المحاولة مره أخرى',
        'Back End Issue'
      );
      toast.error(
        locale === 'en'
          ? 'Error Occured, please try again'
          : 'حدث خطأ, برجاء المحاولة مره أخرى'
      );
    }
  };

  const handleUpdateCart = async (is_minus, item_id, qty) => {
    !is_minus ? setLoading('adding') : setLoading('subtracting');

    const res = await updateCartItem(
      item_id,
      is_minus ? qty - 1 : qty + 1,
      mage,
      quote
    );

    if (res?.status === 404) {
      removeItem(item_id);
    }

    if (res?.data?.quoteId !== undefined && res?.data?.quoteId != quote) {
      setCookie('quote', res?.data?.quoteId);
      resetCart();
    }
    if (res?.status === 200) {
      refetchCart && (await refetchCart());

      setLoading('');
      updateItem(item_id, res?.data?.data?.qty);
      const product = cartItems.find((item) => item.item_id === item_id);
      !!product
        ? is_minus
          ? event_remove_from_cart(product, res?.data?.data?.qty)
          : event_add_to_cart(product, res?.data?.data?.qty)
        : null;
      const index = cartItems.findIndex((item) => item?.sku === product?.sku);
      update_cart_event([
        ...cartItems?.slice(0, index),
        { ...product, qty: res?.data?.data?.qty },
        ...cartItems?.slice(index + 1),
      ]);
      toast.success(
        locale === 'en' ? 'Cart updated successfully' : 'تم تعديل الكمية بنجاح'
      );
    } else {
      event_error_boundry(
        locale === 'en' ? 'No quantities available' : 'لا توجد كميات متاحة',
        'Back End Issue'
      );
      toast.error(
        locale === 'en' ? 'No quantities available' : 'لا توجد كميات متاحة'
      );
      setLoading('');
    }
  };

  const applyCouponHandler = async (coupon) => {
    setLoading('apply_coupon');
    const res = await applyCoupon(mage, quote, coupon);
    if (res?.status === 200) {
      refetchCart && (await refetchCart());
      setLoading('');
      toast.success(
        locale === 'en'
          ? 'Coupon applied successfully'
          : 'تم تطبيق الكوبون بنجاح'
      );
      coupon_redemption(coupon);
    } else {
      setLoading('');
      event_error_boundry(
        locale === 'en' ? 'Invalid Coupon' : 'كوبون غير صحيح',
        'Back End Issue'
      );
      toast.error(locale === 'en' ? 'Invalid Coupon' : 'كوبون غير صحيح');
      coupon_redemption(coupon, false);
    }
  };

  const removeCouponHandler = async () => {
    setLoading('remove_coupon');
    const res = await deleteCoupon(mage, quote);
    if (res?.status === 200) {
      refetchCart && (await refetchCart());
      setLoading('');
      toast.success(
        locale === 'en' ? 'Coupon removed successfully' : 'تم حذف الكوبون بنجاح'
      );
    } else {
      setLoading('');
      event_error_boundry(
        locale === 'en' ? 'Invalid Coupon' : 'كوبون غير صحيح',
        'Back End Issue'
      );
      toast.error(locale === 'en' ? 'Invalid Coupon' : 'كوبون غير صحيح');
    }
  };

  return {
    deleteItemFromCart,
    loading,
    handleUpdateCart,
    applyCouponHandler,
    removeCouponHandler,
  };
};

export default useHandleCart;
